<section
  class="h-[calc(100vh-120px)] overflow-hidden rounded-t-xl bg-white shadow-md"
>
  <div class="h-full overflow-y-auto overflow-x-hidden">
    <div>
      <div
        class="sticky top-0 z-20 border-b border-blue-950 bg-white px-4 pt-2 font-light"
      >
        <div class="mb-2 flex items-center justify-between">
          <span class="flex items-center">
            <mat-icon svgIcon="billing" class="text-blue-950"></mat-icon>
            <h1 class="ml-2">Invoices</h1>
          </span>
          @if (invoices.length > 5) {
            <mat-form-field>
              <mat-select
                [(value)]="invoiceSelectedFilter"
                (selectionChange)="onInvoiceFilterSelect($event)"
              >
                @for (filter of filters; track filter.value) {
                  <mat-option [value]="filter.value">
                    {{ filter.text }} INVOICES
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </div>
      </div>

      @if (isInvoicesLoading) {
        <div class="flex items-center justify-center">
          <mat-spinner [diameter]="30"></mat-spinner>
        </div>
      }
      <div class="list-scroll">
        @if (invoices.length === 0 && !isInvoicesLoading) {
          <div
            class="relative w-full py-8 text-center font-light after:mt-8 after:block after:h-px after:bg-gray-500"
          >
            There are no invoices available for this account yet.
          </div>
        }
        @for (invoice of invoices; track invoice.ContentDocument.Title) {
          <div
            tabindex="0"
            class="list-row group relative flex cursor-pointer items-center border-b border-gray-200 transition-colors duration-200 hover:bg-blue-50 focus:bg-blue-50"
            [class.bg-blue-50]="
              invoice.ContentDocumentId === selectedInvoice.ContentDocumentId
            "
            [class.selected]="
              invoice.ContentDocumentId === selectedInvoice?.ContentDocumentId
            "
            (click)="onSelect(invoice)"
            (keyup.enter)="onSelect(invoice)"
          >
            <div
              class="relative flex w-full flex-wrap items-center justify-between px-5 py-3 pl-5 pr-4 font-light"
            >
              <!-- Date -->
              <div class="text-md flex-1">
                <label
                  class="hidden pb-1 text-xs font-semibold uppercase md:flex"
                  >Date Posted</label
                >
                <label
                  class="flex pb-1 text-xs font-semibold uppercase md:hidden"
                  >Posted</label
                >
                {{
                  invoice.ContentDocument.Title.slice(0, 10)
                    | date: 'yyyy-MM-dd'
                }}
              </div>

              <!-- Sliding PDF button -->
              <button
                class="absolute right-12 top-1/2 z-10 flex h-9 w-9 -translate-y-1/2 translate-x-16 transform items-center justify-center rounded-full opacity-0 transition-all duration-500 ease-out hover:bg-blue-100 focus:outline-none group-focus-within:translate-x-0 group-focus-within:opacity-100 group-hover:translate-x-0 group-hover:opacity-100 group-[.selected]:translate-x-0 group-[.selected]:opacity-100"
                [ngClass]="'download-button' | gainsight: 'billing'"
                (click)="onDownload(invoice); $event.stopPropagation()"
              >
                <mat-icon svgIcon="pdf-file" class="text-blue-500"></mat-icon>
              </button>

              <!-- Arrow (always visible) -->
              <mat-icon
                class="relative z-0 text-sm font-bold text-blue-500"
                fontIcon="arrow_forward_ios"
              ></mat-icon>
            </div>
          </div>
        }
      </div>
    </div>

    <div>
      <div
        class="sticky top-0 z-10 border-b border-blue-950 bg-white px-4 pt-2 font-light"
      >
        <div class="mb-2 flex items-center justify-between">
          <span class="flex items-center">
            <mat-icon svgIcon="billing" class="text-blue-950"></mat-icon>
            <h1 class="ml-2">Payments</h1>
          </span>
          @if (payments.length > 5) {
            <mat-form-field>
              <mat-select
                [(value)]="paymentSelectedFilter"
                (selectionChange)="onPaymentFilterSelect($event)"
              >
                @for (filter of filters; track filter.value) {
                  <mat-option [value]="filter.value">
                    {{ filter.text }} PAYMENTS</mat-option
                  >
                }
              </mat-select>
            </mat-form-field>
          }
        </div>
      </div>

      @if (isPaymentsLoading) {
        <div class="flex items-center justify-center">
          <mat-spinner [diameter]="30"></mat-spinner>
        </div>
      }
      <div class="list-scroll">
        @if (payments.length === 0 && !isPaymentsLoading) {
          <div
            class="relative w-full py-8 text-center font-light after:mt-8 after:block after:h-px after:bg-gray-500"
          >
            There are no payments available for this account yet.
          </div>
        }
        @if (payments.length > 0 && payments.length !== 0) {
          @for (payment of payments; track payment) {
            <div
              tabindex="0"
              class="list-row relative flex items-center border-b border-gray-200"
            >
              <div
                class="relative flex w-full flex-wrap items-center justify-between px-5 py-3 pl-5 pr-4 font-light"
              >
                <div class="text-md flex-1">
                  <label
                    class="hidden pb-1 text-xs font-semibold uppercase md:flex"
                    >Date Posted</label
                  >
                  <label
                    class="flex pb-1 text-xs font-semibold uppercase md:hidden"
                    >Posted</label
                  >
                  {{ payment.Transaction_Date__c | date: 'yyyy-MM-dd' }}
                </div>

                <div class="text-lg font-bold">
                  {{
                    payment.Transaction_Amount__c
                      | positiveNumber
                      | currency: 'USD'
                  }}
                </div>
              </div>
            </div>
          }
        } @else if (payments.length !== 0) {
          <div class="list-empty py-4 text-center">
            There are no payments available based on the filter selection.
          </div>
        }
      </div>
    </div>

    <app-help-cta
      [originPage]="'Billing'"
      class="block md:hidden"
    ></app-help-cta>
  </div>
</section>
